import QueueEntry from '../models/QueueEntry';

/**
 * Sort queue entries so that booked students whose slot time is due
 * (within 9 minutes before slot_time) are promoted to the top.
 *
 * - Promoted: bookingTime - 9 min <= now, type matches booking
 * - Among promoted: earliest bookingTime first, then join time tiebreak
 * - Rest: original server order (join order)
 */
export function sortWithBookingPromotion(entries: QueueEntry[]): QueueEntry[] {
  const now = Date.now();
  const earlyWindow = 9 * 60 * 1000; // 9 minutes

  const promoted: QueueEntry[] = [];
  const rest: QueueEntry[] = [];

  for (const entry of entries) {
    if (
      entry.bookingTime
      && new Date(entry.bookingTime).getTime() - earlyWindow <= now
      && entry.bookingHelp === entry.help
    ) {
      promoted.push(entry);
    } else {
      rest.push(entry);
    }
  }

  promoted.sort((a, b) => {
    const timeDiff = new Date(a.bookingTime!).getTime() - new Date(b.bookingTime!).getTime();
    if (timeDiff !== 0) return timeDiff;
    return a.starttime - b.starttime;
  });

  return [...promoted, ...rest];
}
